import React from "react";
import { Box, Container, Divider, Grid, Link, Paper, Stack } from "@mui/material";
import { Footer, Header, ListingResultText, MixPanelTrackedLink, SearchInput } from "../../components";
import { FiltersIcon } from "../../components/Icons";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { StyledEventCard } from "./styles/EventListStyles";
import { isMobile } from "react-device-detect";
export function EventsList() {
    const events = [
        {
            id: 1,
            date: 'Feb 2, 2023',
            time: '4:30pm',
            title: 'Run For TCF',
            type: 'Marathon',
            location: 'Gaddafi Stadium',
            Country: 'Pakistan',
            banner: 'https://stagingcdn.tcfglobal.org/medium/fundraiser-pages/September2021/fc-575-1631009483.jpg'
        },
        {
            id: 2,
            date: 'Feb 2, 2023',
            time: '4:30pm',
            title: 'Run For TCF',
            type: 'Marathon',
            location: 'Gaddafi Stadium',
            Country: 'Pakistan',
            banner: 'https://stagingcdn.tcfglobal.org/medium/fundraiser-pages/September2021/fc-575-1631009483.jpg'
        },
        {
            id: 3,
            date: 'Feb 2, 2023',
            time: '4:30pm',
            title: 'Run For TCF',
            type: 'Marathon',
            location: 'Gaddafi Stadium',
            Country: 'Pakistan',
            banner: 'https://stagingcdn.tcfglobal.org/medium/fundraiser-pages/September2021/fc-575-1631009483.jpg'
        },
        {
            id: 4,
            date: 'Feb 2, 2023',
            time: '4:30pm',
            title: 'Run For TCF',
            type: 'Marathon',
            location: 'Gaddafi Stadium',
            Country: 'Pakistan',
            banner: 'https://stagingcdn.tcfglobal.org/medium/fundraiser-pages/September2021/fc-575-1631009483.jpg'
        },
        {
            id: 5,
            date: 'Feb 2, 2023',
            time: '4:30pm',
            title: 'Run For TCF',
            type: 'Marathon',
            location: 'Gaddafi Stadium',
            Country: 'Pakistan',
            banner: 'https://stagingcdn.tcfglobal.org/medium/fundraiser-pages/September2021/fc-575-1631009483.jpg'
        },
    ]

    const mapEventCard = () => {
        return events.map(event => {
            return <Grid key={event.id} item xs={6} sm={4} sx={styles.item}>
                <StyledEventCard>
                    <CardMedia
                        image={event.banner}
                        title={event.title}
                        sx={{ height: '200px' }}
                    />
                    <CardContent>
                        <Typography component="div" className="DateTimeTag">
                            <Typography component="span" variant="bold">{event.date}</Typography> / {event.time}
                        </Typography>
                        <Typography variant="h5" component="div" className="Title">
                            {event.title}
                        </Typography>
                        <Typography gutterBottom variant="body2" color="text.secondary">
                            {event.type}
                        </Typography>
                        <Typography className="Location">{event.location}</Typography>
                        <Typography variant="h6" className="CountryName">{event.Country}</Typography>
                        <Divider />
                    </CardContent>
                    <CardActions>
                        <MixPanelTrackedLink
                            type="button"
                            label="View Event"
                            context="Event listing page"
                            variant="contained"
                            sx={{ mb: 1 }}
                        >
                            View Event
                        </MixPanelTrackedLink>
                    </CardActions>
                </StyledEventCard>
            </Grid>
        })
    }
    return <React.Fragment>
        <Header />
        <Container component="main">
            <Stack direction="row" spacing={2}>
                <SearchInput
                    size="small"
                    placeholder="Search Here"
                    sx={styles.searchField}
                />
                <MixPanelTrackedLink
                    type="button"
                    label="Filter"
                    context="Fundraiser listing page"
                    variant="outlined"
                    // onClick={openModal} 
                    startIcon={<FiltersIcon />}
                >
                    Filter
                </MixPanelTrackedLink>
            </Stack>
            <ListingResultText resultCount={488} filtersCount={1} />
            <Grid container justifyContent="space-between" spacing={{xs: 0, sm: 4}} sx={styles.container}>
                {mapEventCard()}

                {/* Added the following item to balance the UI if a row contains two records */}
                <Grid item xs={6} sm={4}></Grid>
            </Grid>
        </Container>
        <Footer />
    </React.Fragment>
}

const styles = {
    container: {
        gap: isMobile ? '5px' : 'unset'
    },
    item: {
        maxWidth: isMobile ? 'calc(50% - 2.5px)' : 'unset'
    },
    searchField: {
        '& .MuiInputBase-input': {
            fontSize: '0.875rem'
        }
    },
    infinityLoader: {
        overflow: 'none',
        marginTop: '30px'
    }
}